import * as apiServices from "../services/apiServices";
import request from "../services/requestService";
import store from "../../src/store";
import { DASHBOARD } from "../constant";
import { getProjectStageWisePendingIssuesWithRecipientService } from "../services/apiServices";

// Api of first page of pdf start

export const getPMGMonitoredIssuesAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(apiServices.getPMGMonitoredIssuesService(params))
    .then(response => response.data)
    .catch(err => err);
};

export const getPMGMonitoredProjectAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(apiServices.getPMGMonitoredProjectService(params))
    .then(response => response.data)
    .catch(err => err);
};

export const getIssueByCategoryAction = (requestMethod = request) => {
  return requestMethod(apiServices.getIssueByCategoryService())
    .then(response => response.data)
    .catch(err => err);
};

// Dashboard Projects Status Graph
export const getProjectsByCompletionStageAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(apiServices.getProjectsByCompletionStageService(params))
    .then(response => response.data)
    .catch(err => err);
};

export const _getProjectsByCompletionStageAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: DASHBOARD.PROJECT_STAGES_GRAPHS_START
    });
    return requestMethod(
      apiServices.getProjectsByCompletionStageService(params)
    )
      .then(resp => {
        const {
          data: { data }
        } = resp;

        dispatch({
          type: DASHBOARD.PROJECT_STAGES_GRAPHS_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(() => {
        dispatch({
          type: DASHBOARD.PROJECT_STAGES_GRAPHS_FAILURE
        });
      });
  };
};

// Api of second page of pdf start

export const getProjectsByImplementationModeAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(
    apiServices.getProjectsByImplementationModeService(params)
  )
    .then(response => response.data)
    .catch(err => err);
};

export const getUnderImplementationProjectsByAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(
    apiServices.getUnderImplementationProjectsBySectorService(params)
  )
    .then(response => response.data)
    .catch(err => err);
};

export const getProjectsStatusWithRespectToIssueStatusAction = (
  requestMethod = request
) => {
  return requestMethod(
    apiServices.getProjectsStatusWithRespectToIssueStatusService()
  )
    .then(response => response.data)
    .catch(err => err);
};

export const getOpenProjectsByImplementationModeAction = (
  requestMethod = request
) => {
  return requestMethod(apiServices.getOpenProjectsByImplementationModeService())
    .then(response => response.data)
    .catch(err => err);
};

/////////////////////////////////////////////////////////////
//////////////////////// Third page of pdf actions /////////

export const getOpenProjectSectorDistributionAction = (
  requestMethod = request,
  data
) => {
  return requestMethod(
    apiServices.getOpenProjectSectorDistributionService(data)
  )
    .then(response => response.data)
    .catch(err => err);
};

export const getResolvedProjectSectorDistributionAction = (
  requestMethod = request,
  data
) => {
  return requestMethod(
    apiServices.getResolvedProjectSectorDistributionService(data)
  )
    .then(response => response.data)
    .catch(err => err);
};

export const getProjectSectorDistributionByCreatedDateAction = (
  requestMethod = request,
  data
) => {
  return requestMethod(
    apiServices.getProjectSectorDistributionByCreatedDateService(data)
  )
    .then(response => response.data)
    .catch(err => err);
};

export const chartsLoadedAction = action => {
  store.dispatch(action);
};

export const chartsClearLoadedAction = () => {
  store.dispatch({
    type: "CLEAR_PDF_REPORTS"
  });
};

/////////////////////////////////////////////////////////////
//////////////////////// Fourth page of Pie Charts /////////

export const getProjectCostOverRunAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(
    apiServices.getProjectCostOverRunDistributionService(params)
  )
    .then(response => response.data)
    .catch(err => err);
};

export const getProjectDelayedAction = (requestMethod = request, data) => {
  return requestMethod(apiServices.getProjectDelayedDistributionService(data))
    .then(response => response.data)
    .catch(err => err);
};

//Additional Milestone Graphs
export const getProjectStageWisePendingIssuesAction = (
  requestMethod = request,
  data
) => {
  return requestMethod(
    apiServices.getProjectStageWisePendingIssuesService(data)
  )
    .then(response => response.data)
    .catch(err => err);
};

export const getAverageBucketWiseDelayAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(apiServices.getAverageBucketWiseDelayService(params))
    .then(response => response.data)
    .catch(err => err);
};

export const getProjectStageWisePendingIssuesWithRecipientAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(
    apiServices.getProjectStageWisePendingIssuesWithRecipientService(params)
  )
    .then(response => response.data)
    .catch(err => err);
};
